import { useSWRConfig } from "swr";
import useMutation from "hooks/useMutation";
import OneRepMaxService from "services/OneRepMaxService";
import { getOneRepMaxesByAthleteIdsCacheKeyMatcher } from "hooks/useGetOneRepMaxesByAthleteIdsQuery";
import { getAthleteOneRepMaxesCacheKeyMatcher } from "hooks/useGetAthleteOneRepMaxesQuery";
import type { OneRepMaxesUpdate, OneRepMaxValue } from "types/onerepmax";

const key = "OneRepMaxService.updateByAthleteIds";

/**
 * Adds 1RMs for several athletes, then revalidates every cached 1RM list that could include them.
 */
function useOneRepMaxUpdateByAthleteIdsMutation() {
  const { mutate } = useSWRConfig();

  return useMutation<Pick<OneRepMaxValue, "id">[], Error, string, OneRepMaxesUpdate[]>(key, async (_, { arg }) => {
    const result = await OneRepMaxService.updateByAthleteIds(arg);
    const matchers = [
      getOneRepMaxesByAthleteIdsCacheKeyMatcher(),
      ...arg.map(({ athleteId }) => getAthleteOneRepMaxesCacheKeyMatcher(athleteId)),
    ];
    await mutate((cacheKey) => matchers.some((matches) => matches(cacheKey)));
    return result;
  });
}

export default useOneRepMaxUpdateByAthleteIdsMutation;
